import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface BackofficeStatus {
  status: string;
  username: string;
}

/**
 * Calls backoffice-be's own /v1/status (see StatusController), reached through api-gateway
 * ("/backoffice" -> api-gateway -> backoffice-be). The route requires a valid session, so a
 * successful response proves the whole chain works: login -> JWT -> gateway -> SESSION_ID ->
 * Redis -> resolved user, not just that the backend process is reachable.
 */
@Injectable({ providedIn: 'root' })
export class StatusService {
  private http = inject(HttpClient);

  getStatus(): Observable<BackofficeStatus> {
    return this.http.get<BackofficeStatus>('/backoffice/v1/status');
  }
}
